import { Form, Input } from "antd";
import { forwardRef } from "react";

const EditMenu = forwardRef(({ info, dataSource }, menuRef) => {

  function validator(_, value) {
    const newData = menuRef.current.getFieldsValue();
    for (let el of dataSource) {
      if (el.id !== newData.menuId && el.menu_name === newData.menuName) {
        return Promise.reject(
          new Error(`메뉴에 "${el.menu_name}"가 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  }

  return (
    <div>
      <Form
        ref={menuRef}
        layout="vertical"
        initialValues={{
          menuUrl: info.menu_url,
          menuCode: info.menu_code,
          menuName: info.menu_name,
          menuId: info.id,
        }}
      >
        <Form.Item name="menuId" label="ID" hidden={true}>
          <Input disabled={true}></Input>
        </Form.Item>
        <Form.Item name="menuCode" label="메뉴코드">
          <Input disabled={true}></Input>
        </Form.Item>
        <Form.Item
          name="menuName"
          label="메뉴명칭"
          rules={[
            { required: true, message: "관리메뉴 명칭을 입력해 주세요." },
            { validator: validator },
          ]}
        >
          <Input></Input>
        </Form.Item>
        <Form.Item
          name="menuUrl"
          label="메뉴 URL"
          rules={[{ required: true, message: "관리메뉴 URL을 입력해 주세요." }]}
        >
          <Input addonBefore="https://"></Input>
        </Form.Item>
      </Form>
    </div>
  );
});
export default EditMenu;
